const accordionBtns = document.querySelectorAll(".accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    let iconPlus = this.querySelector(".icon-plus");
    let iconMinus = this.querySelector(".icon-minus");

    // Toggle visibility of icons based on is-open class
    if (this.classList.contains("is-open")) {
      iconPlus.classList.add("hidden");
      iconMinus.classList.remove("hidden");
    } else {
      iconPlus.classList.remove("hidden");
      iconMinus.classList.add("hidden");
    }

    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };
});
